import { render } from "./ButtonsField.vue?vue&type=template&id=5670bd48"
import script from "./ButtonsField.vue?vue&type=script&lang=js"
export * from "./ButtonsField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ButtonsField.vue"]])

export default __exports__